"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExistsStreamPolicy = void 0;
var ExistsStreamPolicy;
(function (ExistsStreamPolicy) {
    ExistsStreamPolicy[ExistsStreamPolicy["stale"] = 0] = "stale";
    ExistsStreamPolicy[ExistsStreamPolicy["wait"] = 1] = "wait";
    // may not work in certain browsers
    ExistsStreamPolicy[ExistsStreamPolicy["ignore"] = 2] = "ignore";
    ExistsStreamPolicy[ExistsStreamPolicy["error"] = 3] = "error";
})(ExistsStreamPolicy || (exports.ExistsStreamPolicy = ExistsStreamPolicy = {}));
//# sourceMappingURL=media-stream-controller.js.map